'use client';

import { useEffect } from 'react';
import useViewedLocationPage from '@alltrails/core/hooks/useViewedLocationPage';

/** Runs once on the client when LocationPage mounts so localStorage records this visit. */
export default function ViewedLocationPageMarker() {
  const { markViewedLocationPage } = useViewedLocationPage();

  useEffect(() => {
    markViewedLocationPage();
  }, [markViewedLocationPage]);

  return null;
}
